﻿export default class ListControl {
    constructor(options) {
        this.isPreview = options.IsPreview;
        this.idMediaField = options.IdMediaField;
        this.layoutResources = options.LayoutResources;
        this.formMetadata = options.FormMetadata;
        this.filterId = options.FilterId;
        this.entityId = options.IdEntity;
        this.listId = options.Id;
        this.listDescription = options.Description;
        this.listName = options.Name;
        this.currentUrl = options.CurrentUrl;
        this.containerId = options.ContainerId;
        this.getDataUrl = options.GetDataUrl;
        this.editItemUrl = options.EditItemUrl;
        this.displayContext = options.Context;
        this.uiActionResources = options.UiActionResources;
        this.listType = options.ListType;
        this.uniqueId = options.PageGuid.replaceAll('-', '');
        this.uniqueControlId = 'listControl' + this.uniqueId;
        this.fieldPrefix = 'fld_';
        this.uiLayoutId = options.uiLayoutId;
        this.parentPkVal = options.parentPkVal;
        this.rootUrl = options.RootUrl;
        this.itemActions = options.ItemButtons;
        this.groupable = options.Groupable;
        this.idField = options.PkFieldName;
        this.pageUniqueIdentifier = options.PageGuid;
        this.pageType = options.PageType;
        this.returnUrl = options.ReturnUrl;
        this.sortType = options.SortType;
        this.parent = options.Parent;
        this.styleApplied = false;
        this.currentCsvCommand = null;
        this.urlParameters = options.UrlParameters;
        this.pageable = {
            pageSize: 10,
            pageSizes: [10, 25, 50]
        };
        this.generalResources = options.GeneralResources;
        this.entityFormResources = options.EntityFormResources;
        this.listControlId = ('entity_list_' + this.uniqueId).replaceAll('-', '_');
        this.listControlCarouselId = this.listControlId + '_carousel';
        this.listControlTitleId = ('entity_list_title_' + this.uniqueId).replaceAll('-', '_');
        this.csvInputId = ('entity_list_csv_input_' + this.uniqueId).replaceAll('-', '_');
        this.filterControlId = 'filter-control-id' + this.uniqueId;
        this.modalInner = 'sublist-modal-' + this.uniqueId;
        this.modalWrapperUniqueId = 'list-modal-' + this.uniqueId;
        this.filterControl = null;
        this.filters = {};
        this.toolbarActions = this.getToolbarButtons(options.ToolbarButtons);
        this.fields = this.extractFields(options.Fields);
        this.lastListHeight = null;
        this.commands = [];
        this.initListControl();
        window[this.uniqueControlId] = this;
    }

    reloadList(options) {
        this.styleApplied = false;
        $('#' + this.containerId)[0].innerHTML = '';
        this.listDescription = options.Description;
        this.listType = options.ListType;
        this.listName = options.Name;
        this.toolbarActions = this.getToolbarButtons(options.ToolbarButtons);
        this.itemActions = options.ItemButtons;
        this.fields = this.extractFields(options.Fields);
        this.groupable = options.Groupable;
        this.idField = options.PkFieldName;
        this.pageType = options.PageType;
        this.sortType = options.SortType;
        this.initListControl();
    }

    destroy() {
        if ($('#' + this.containerId).length > 0) {
            $('#' + this.containerId)[0].innerHTML = '';
        }
    }

    initListControl() {
        let commandsUrl = rootUrl + 'EntityList/GetXpCommandsRuntime?idList=' + this.listId;
        this.initStructure();

        if (this.listType == 'GRID') {
            this.filterControl = new FormControl({
                localization: this.layoutResources,
                actionLocalization: this.uiActionResources,
                isPreview: this.isPreview,
                container: this.filterControlId,
                pageGuid: this._generateUUID(),
                objectId: '0',
                formId: this.listId,
                layoutId: this.filterId,
                isFilter: true,
                listControl: (this.isPreview ? null : this),
                generalResources: this.generalResources,
                customFormResources: this.customFormResources
            });

            this.filterControl.loadForm(this.formMetadata, []);
        }

        $.ajax({
            type: "GET",
            url: commandsUrl,
            contentType: "application/json; charset=utf-8",
            success: (result) => {
                this.commands = result;
                if (window['onBeforeListLoaded' + this.uniqueId] != null) {
                    window['onBeforeListLoaded' + this.uniqueId]();
                }

                switch (this.listType) {
                    case 'GRID': this._initGridControl();
                        break;
                    case 'CAROUSEL': this._initCarouselControl();
                        break;
                    default: this._initGridControl();
                        break;
                }

                if (window['onListLoaded' + this.uniqueId] != null) {
                    window['onListLoaded' + this.uniqueId]();
                }

                this.applyStyles();
            },
            error: (e) => {
                toastr.error(e.responseText);
            }
        });
    }

    executeCommandById(id, params, item) {
        let foundCommands = this.commands.filter((row) => { return row.Id == id });

        if (foundCommands.length > 0) {
            return this._executeCommand(foundCommands[0], params, item);
        } else {
            throw 'Command does not exist!';
        }
    }

    executeCommandByName(name, params, item) {
        let foundCommands = this.commands.filter((row) => { return row.Name == name });

        if (foundCommands.length > 0) {
            if (foundCommands.length > 0) {
                return this._executeCommand(foundCommands[0], params, item);
            } else {
                throw 'Command does not exist!';
            }
        } else {
            throw 'Command does not exist!';
        }
    }

    refresh() {
        $('#' + this.listControlId).data('kendoGrid').dataSource.read();
    }

    _executeCommand(command, params, item) {
        if (command.Type == 'CLIENT') {
            return new Promise((resolve, reject) => {
                try {
                    let result = window['command_' + this.uniqueId + '_' + command.Id]();

                    resolve(result);
                } catch (err) {
                    reject(err);
                }
            });
        } else if (command.Type == 'SERVER_WITH_RESULT') {
            return new Promise((resolve, reject) => {
                try {
                    let postData = {
                        id: command.Id,
                        idEntity: this.entityId,
                        params: {}
                    };

                    if (params != null) {
                        postData.params = params;
                    } else if (item != null) {
                        for (var i = 0; i < command.Parameters.length; i++) {
                            let field = item[command.Parameters[i]];

                            if (command.Parameters[i] != 'User.Id' && field != null) {
                                let type = field.fieldDataType;

                                postData.params[command.Parameters[i]] = {
                                    value: field.value,
                                    type: type
                                }
                            }
                        }
                    } else {
                        reject('Cannot autodetect parameters for command!');
                    }

                    let commandUrl = rootUrl + 'EntityList/ExecuteCommandWithResult';

                    $.ajax({
                        type: "POST",
                        url: commandUrl,
                        async: true,
                        data: JSON.stringify(postData),
                        contentType: "application/json; charset=utf-8",
                        success: (result) => {
                            if (result != null) {
                                var resp = JSON.parse(result);

                                if (resp.length == 0) {
                                    resolve(null);
                                } else if (resp.length == 1) {
                                    resolve(resp[0]);
                                } else {
                                    resolve(resp);
                                }
                            }
                        },
                        error: (e) => {
                            reject(e)
                        }
                    });
                } catch (err) {
                    reject(err);
                }
            });
        } else if (command.Type == 'SERVER_NO_RESULT') {
            return new Promise((resolve, reject) => {
                try {
                    let postData = {
                        id: command.Id,
                        idEntity: this.entityId,
                        params: {}
                    };

                    if (params != null) {
                        postData.params = params;
                    } else if (item != null) {
                        for (var i = 0; i < command.Parameters.length; i++) {
                            let field = item[command.Parameters[i]];

                            if (command.Parameters[i] != 'User.Id' && field != null) {
                                let type = field.fieldDataType;

                                postData.params[command.Parameters[i]] = {
                                    value: field.value,
                                    type: type
                                }
                            }
                        }
                    } else {
                        reject('Cannot autodetect parameters for command!');
                    }

                    let commandUrl = rootUrl + 'EntityList/ExecuteCommandWithoutResult';

                    $.ajax({
                        type: "POST",
                        url: commandUrl,
                        async: true,
                        data: JSON.stringify(postData),
                        contentType: "application/json; charset=utf-8",
                        success: (result) => {
                            if (result != null) {
                                if (result.status == true) {
                                    resolve(true);
                                } else {
                                    resolve(false);
                                }
                            } else {
                                resolve(false);
                            }
                        },
                        error: (e) => {
                            reject(e)
                        }
                    });
                } catch (err) {
                    reject(err);
                }
            });
        } else {
            throw 'Command type not implemented!';
        }
    }

    _initCarouselControl() {
        if (this.isPreview) {
            this._initPreviewCarouselControl();
        } else {
            let dataSourceUrl = '';

            if (this.getDataUrl == null || this.getDataUrl.trim() == '') {
                if (this.parent != null) {
                    dataSourceUrl = 'EntityList/GetSubListData';
                } else {
                    dataSourceUrl = 'EntityList/GetData';
                }
            } else {
                dataSourceUrl = this.getDataUrl.substring(1);
            }

            let data = {};

            if (this.parent != null) {
                dataSourceUrl += '?idUISubList=' + this.uiLayoutId + '&pkVal=' + this.parentPkVal;
            } else {
                dataSourceUrl += '?id=' + this.listId;
            }
            dataSourceUrl += '&filters=' + JSON.stringify(this.filters);
            dataSourceUrl = this.rootUrl + dataSourceUrl;

            if (this.displayContext == 'modal' && this.parent == null) {
                $('#' + this.containerId).closest('.k-window-content.k-content').data('kendoWindow').center();
            } else if (this.parent != null) {
                this.parent.centerForm();
            }

            $.ajax({
                type: "GET",
                url: dataSourceUrl,
                contentType: "application/json; charset=utf-8",
                success: (result) => {
                    this._initRuntimeCarouselControl(result);
                },
                error: (e) => {
                    toastr.error(e.responseText, this.getEntityFormResources('GetListError'));
                }
            });
        }
    }

    _initRuntimeCarouselControl(remoteData) {
        let runtimeDataset = [];

        remoteData.Data.forEach(item => {
            let remoteItem = {};

            this.fields.forEach(field => {
                remoteItem[field.id] = {
                    value: item[field.id],
                    fieldDataType: field.fieldDataType,
                    name: field.name,
                    format: field.format,
                    width: field.width,
                    controlType: field.controlType,
                    htmlAttributes: field.htmlAttributes,
                    id: field.id
                }
            });

            if (item['fld_0'] != null) {
                remoteItem['fld_0'] = {
                    value: item['fld_0'] == true ? (this.rootUrl + 'Entity/GetFileContent?idEntityField=' + this.idMediaField + '&pkVal=' + item[this.idField]) : null,
                    controlType: 'IMAGE',
                    id: 'fld_0'
                }
            }

            remoteItem.pkVal = item[this.idField];
            runtimeDataset.push(remoteItem);
        });

        if (this.parent == null && this.displayContext == 'modal') {
            $('#' + this.listControlId).parent().append(`<div id="` + this.modalWrapperUniqueId + `"></div>`);
        }

        $('#' + this.listControlId).append(this._getCarouselTemplate(runtimeDataset));

        this._addEventsForActionButtons();
    }

    _initPreviewCarouselControl() {
        let previewData = this.getPreviewData(3);
        let previewDataset = [];

        previewData.Data.forEach(item => {
            let keys = Object.keys(item);
            let previewItem = {};

            keys.forEach(key => {
                let fieldItems = this.fields.filter(row => { return row.id == key });

                if (fieldItems.length == 1) {
                    let fieldItem = fieldItems[0];
                    previewItem[key] = {
                        value: item[key],
                        fieldDataType: fieldItem.fieldDataType,
                        name: fieldItem.name,
                        format: fieldItem.format,
                        width: fieldItem.width,
                        controlType: fieldItem.controlType,
                        htmlAttributes: fieldItem.htmlAttributes,
                        id: key
                    }
                }
            });

            previewDataset.push(previewItem);
        });

        $('#' + this.listControlId).append(this._getCarouselTemplate(previewDataset));
    }

    _getCarouselTemplate(items) {
        let template = `<div class="col-sm-12 mb-2 pr-0">
                            <div class="form-group d-flex">`;

        for (let i = 0; i < this.toolbarActions.length; i++) {
            let toolbarAction = this.toolbarActions[i];

            let ml = 'ml-2';

            if (i == 0) {
                ml = 'ml-auto';
            }

            let classPart = toolbarAction.attr.substr(toolbarAction.attr.indexOf('class="') + 'class="'.length);
            let actualClass = classPart.substr(0, classPart.indexOf('"'));
            toolbarAction.attr = toolbarAction.attr.replaceAll('class="' + actualClass + '"', '');
            toolbarAction.attr += 'class="' + actualClass + ' ' + ml + ' btn"';

            let actionButtonIconTemplate = ``;

            if (toolbarAction.iconClass != null && toolbarAction.iconClass != '') {
                actionButtonIconTemplate = `<i class="` + toolbarAction.iconClass + ` mr-2"></i>`
            }

            template += `<button ` + toolbarAction.attr + ` title="` + toolbarAction.text + `" style="line-height: 1.2rem;">` + actionButtonIconTemplate + `<span>` + toolbarAction.text + `</span>` + `</button>`
        };

        template += `</div></div>`;

        template += `<div id="` + this.listControlCarouselId + `" class="carousel slide" data-ride="carousel" style="` + (this.toolbarActions.length > 0 ? `height: calc(100% - 2rem);` : `height: 100%;`) + `">`;

        template += `<ol class="carousel-indicators">`;

        for (let i = 0; i < items.length; i++) {
            template += `<li data-target="#` + this.listControlCarouselId + `" data-slide-to="` + i + `" class="` + (i == 0 ? `active` : `` ) + `"></li>`;
        }

        template += `</ol>`;

        template += `<a class="carousel-control-prev" href="#` + this.listControlCarouselId + `" role="button" data-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                    </a>
                    <a class="carousel-control-next" href="#` + this.listControlCarouselId + `" role="button" data-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                    </a>`;

        template += `<div class="carousel-inner" style="height: 100%;">`;

        for (let i = 0; i < items.length; i++) {
            template += `<div class="carousel-item` + (i == 0 ? ` active` : ``) + `" style="height: 100%; background-color: black;">`;
            template += `<div style="width: 100%; height: 100%; justify-content: center; display: flex; ">`;

            let imageField = this._getCarouselImageField(items[i]);

            if (imageField == null || imageField.value == null) {
                imageField = {
                    id: 'fld_0',
                    value: this.rootUrl + 'img/card-backgrounds/cover-' + ((i % 3) + 1) + '-lg.png'
                }
            }

            template += `<img class="d-block" src="` + imageField.value + `" style="margin: 0 auto; width: auto; min-height: 16px;">`;

            template += `<div class="carousel-caption-options"><div class="carousel-inner-caption-options">`;

            for (let j = 0; j < this.itemActions.length; j++) {
                let itemAction = this.itemActions[j];

                let ml = 'ml-2';

                if (j == 0) {
                    ml = 'ml-auto';
                }

                let classPart = itemAction.attr.substr(itemAction.attr.indexOf('class="') + 'class="'.length);
                let actualClass = classPart.substr(0, classPart.indexOf('"'));
                itemAction.attr = itemAction.attr.replaceAll('class="' + actualClass + '"', '');
                itemAction.attr += 'class="' + actualClass + ' ' + ml + ' btn ' + 'list-action-button' + this.uniqueId + '"';

                let actionButtonIconTemplate = ``;

                if (itemAction.iconClass != null && itemAction.iconClass != '') {
                    actionButtonIconTemplate = `<i class="` + itemAction.iconClass + `"></i>`
                }

                template += `<button ` + itemAction.attr + ` action-type="element" item-id="` + items[i].pkVal + `" action-idx="` + j + `" title="` + itemAction.text + `" style="line-height: 0;">` + actionButtonIconTemplate + `<span>` + itemAction.text + `</span>` + `</button>`
            };

            template += '</div></div>';

            template += `<div class="carousel-caption">`;
            template += `<div class="carousel-inner-caption">`;
            let descriptionFields = this._getCarouselDescriptionFields(items[i]);

            for (let j = 0; j < descriptionFields.length; j++) {
                if (descriptionFields[j].value != null) {
                    if (j == 0) {
                        template += `<h5>` + descriptionFields[j].value + `</h5>`;
                    } else {
                        template += `<p>` + descriptionFields[j].value + `</p>`;
                    }
                }
            }

            template += `</div>`;
            template += `</div>`;
            template += `</div>`;
            template += `</div>`;
        }

        template += `</div>`;
        template += `</div>`;

        return template;
    }

    _getCarouselDescriptionFields(item) {
        let keys = Object.keys(item);

        let result = [];

        keys.forEach(key => {
            if (item[key].controlType == 0) {
                result.push(item[key]);
            }
        });

        return result;
    }

    _getCarouselImageField(item) {
        return item['fld_0'];
    }

    _getMasterColumnsWidth(tbl) {
        var result = 0;
        tbl.children("colgroup").find("col").each(function (idx, element) {
            result += parseInt($(element).outerWidth() || 0, 10);
        });

        return result;
    }

    _adjustLastColumn() {
        this.applyStyles();

        if (this.lastListHeight == null) {
            let listHeight = $('#' + this.listControlId + ' .k-grid-content-locked').css('height');

            if (listHeight != null) {
                let currentListHeight = new Number(listHeight.replaceAll('px', ''));
                this.lastListHeight = currentListHeight + 5;
                document.querySelector('#' + this.listControlId + ' .k-grid-content-locked').style.setProperty('height', this.lastListHeight + 'px');
            }
        } else {
            let listHeight = $('#' + this.listControlId + ' .k-grid-content-locked').css('height');

            if (this.lastListHeight + 'px' != listHeight) {
                let currentListHeight = new Number(listHeight.replaceAll('px', ''));
                this.lastListHeight = currentListHeight + 5;
                document.querySelector('#' + this.listControlId + ' .k-grid-content-locked').style.setProperty('height', this.lastListHeight + 'px');
            }
        }

        var grid = $("#" + this.listControlId).data("kendoGrid");
        var contentDiv = grid.wrapper.children(".k-grid-content");
        var masterHeaderTable = grid.thead.parent();
        var masterBodyTable = contentDiv.children("table");
        var gridDivWidth = contentDiv.width() - kendo.support.scrollbar();

        masterHeaderTable.width("");
        masterBodyTable.width("");

        var headerWidth = this._getMasterColumnsWidth(masterHeaderTable);
        var lastHeaderColElement = grid.thead.parent().find("col");
        var lastDataColElement = grid.tbody.parent().children("colgroup").find("col");
        var delta = parseInt(gridDivWidth, 10) - parseInt(headerWidth, 10);



        if (delta > 0) {
            delta = Math.abs(delta);

            for (var i = 0; i < lastHeaderColElement.length; i++) {
                $(lastHeaderColElement[i]).width($(lastHeaderColElement[i]).width() + delta / lastHeaderColElement.length);
            }

            for (var i = 0; i < lastDataColElement.length; i++) {
                $(lastDataColElement[i]).width($(lastHeaderColElement[i]).width());
            }
        }

        this.applyListStyle('.k-grid-content-locked', 'height', 'auto', 'important');
        this.applyListStyle('.k-grid-norecords', 'border', 'none');

        $('#' + this.listControlId + ' .k-grid-content tr').css('height', 'auto');

        let rows = $('#' + this.listControlId + ' .k-grid-content tr');

        for (let i = 0; i < rows.length; i++) {
            if (i < rows.length - 1) {
                $($('#' + this.listControlId + ' .k-grid-content-locked tr')[i]).height($(rows[i]).height());
            } else {
                $($('#' + this.listControlId + ' .k-grid-content-locked tr')[i]).height($(rows[i]).height() + 1);
            }
        }

        if ($('#' + this.listControlId + ' .k-grid-content.k-auto-scrollable').length > 0 && ($('#' + this.listControlId + ' .k-grid-content.k-auto-scrollable')[0].scrollWidth > $('#' + this.listControlId + ' .k-grid-content.k-auto-scrollable')[0].clientWidth)) {
            if ($('#' + this.listControlId + ' .k-custom-scroll-padding').length == 0) {
                $('#' + this.listControlId + ' .k-grid-content.k-auto-scrollable').siblings('.k-grid-content-locked').append(`<div class="k-custom-scroll-padding" style="height: 8px; background-color: #f1f1f1; border-bottom: 1px solid rgba(33, 37, 41, 0.125);"></div>`);
            }
        } else if ($('#' + this.listControlId + ' .k-custom-scroll-padding').length > 0) {
            $('#' + this.listControlId + ' .k-custom-scroll-padding').remove();
        }

        setTimeout(() => {
            $('#' + this.listControlId + ' .k-grid-content.k-auto-scrollable').children('table').width($('#' + this.listControlId + ' .k-grid-content.k-auto-scrollable').width());
            $('#' + this.listControlId + ' .k-grid-content.k-auto-scrollable').width($('#' + this.listControlId + ' .k-grid-header-wrap.k-auto-scrollable').width());
        }, 500);
    }

    _initGridControl() {
        if (this.parent == null && this.displayContext == 'modal') {
            $('#' + this.listControlId).parent().append(`<div id="` + this.modalWrapperUniqueId + `"></div>`);
        }

        let options = {
            noRecords: true,
            messages: {
                noRecords: this.getGeneralResource('Grid_NoRecord')
            },
            groupable: this.groupable, 
            sortable: this.getSortable(),
            pageable: this.getPageable(),
            columns: this.getColumns(!this.groupable),
            dataSource: this.getDataSource(),
            toolbar: this.toolbarActions,
            pdf: {
                allPages: true,
                avoidLinks: true,
                paperSize: "A4",
                margin: { top: "2cm", left: "1cm", right: "1cm", bottom: "1cm" },
                landscape: true,
                repeatHeaders: true,
                scale: 0.8
            },
            scrollable: !this.groupable,
            excel: {
                allPages: true,
                fileName: this.listName + '.xlsx',
                filterable: true
            },
            dataBound: (e) => {
                if (e.sender.dataSource.data().length > 0) {
                    this.applyListStyle('.k-grid-content-locked', 'border-bottom', 'none');
                }

                if (this.displayContext == 'modal' && this.parent == null) {
                    $('#' + this.containerId).closest('.k-window-content.k-content').data('kendoWindow').center();
                } else if (this.parent != null) {
                    this.parent.centerForm();
                }

                this._adjustLastColumn();
            },
            excelExport: function (e) {
                var sheet = e.workbook.sheets[0];
                sheet.columns.forEach(x => { x.autoWidth = true; });
            }
        };

        if (this.getPageable() != false) {
            options.pageSize = this.pageable.pageSize;
        }

        this.listControl = $('#' + this.listControlId).kendoGrid(options);

        this._addEventsForActionButtons();
        this._addEventsForCsvInput();
    }

    _addEventsForActionButtons() {
        $('.list-action-button' + this.uniqueId).on('click', (evt) => {
            if (evt.currentTarget.getAttribute('action-type') == 'element') {
                let actionDescription = this.itemActions[evt.currentTarget.getAttribute('action-idx')];
                actionDescription.id = actionDescription.name.replaceAll('custom_', '');
                let pkVal = evt.currentTarget.getAttribute('item-id');
                let item = {};
                item[this.idField] = pkVal;

                this.handleItemAction(item, actionDescription.click, actionDescription);
            } else {
                let clickAction = $(evt.currentTarget).attr('btn-click');

                if (clickAction != null && clickAction.trim() != '') {
                    let actionId = $(evt.currentTarget).attr('action-id')

                    switch (clickAction) {
                        case 'btnJsItem_onClick': this._handleGeneralJavascript(actionId);
                            break;
                        case 'btnImportExcelItem_onClick': this._handleGeneralImportExcel(actionId);
                            break;
                        case 'btnRefresh_onClick': this._handleRefresh();
                            break;
                        default: break;
                    }
                } else {
                    var url = $(evt.currentTarget).attr('action-url');

                    if (url != null && url != '') {
                        evt.preventDefault();

                        if (this.parent == null && this.displayContext != 'modal') {
                            //TODO Cristian 19.06.2023 - De venit cu o idee mai buna
                            if (url.indexOf('EntityFormRuntime') > -1) {
                                $.pjax({ url: url, container: '#js-page-content', timeout: 10000 });
                            } else {
                                window.location.href = url;
                            }
                        } else {
                            this._initModal(url);
                        }
                    }
                }
            }
        });
    }

    _addEventsForCsvInput() {
        $('#' + this.csvInputId).on('change', () => {
            let reader = new FileReader();
            reader.onload = () => {
                let csvResult = reader.result;
                let csvData = this._csvToArray(csvResult);
                let uiUrl = rootURL + 'UILayout/GetUILayoutByIdForm?idForm=' + this.currentCsvCommand.formId;
                $.ajax({
                    url: uiUrl,
                    type: 'GET',
                    async: true,
                    dataType: 'json',
                    contentType: "application/json",
                    success: (uiLayout) => {
                        this._handleImport(uiLayout, csvData, this.currentCsvCommand.formId);
                    }
                });

                $('#' + this.csvInputId).val('');
            };

            reader.readAsText($('#' + this.csvInputId)[0].files[0]);
        });
    }

    _handleImport(layout, csvData, formId) {
        let fields = [];
        let csvFields = [];

        this._extractFields(layout, fields);

        for (let i = 0; i < csvData[0].length; i++) {
            let column = csvData[0][i];
            let field = fields.filter(row => { return row.EntityField.FieldName == column });

            if (field.length > 0) {
                field[0].csvIndex = i;
                csvFields.push(field[0]);
            }
        }

        if (csvFields.length == 0) {
            return;
        }

        let postData = [];

        for (let i = 1; i < csvData.length; i++) {
            let row = csvData[i];

            let postItem = {
                idForm: formId,
                pkVal: null,
                values: {}
            };

            for (let j = 0; j < csvFields.length; j++) {
                let csvValue = row[csvFields[j].csvIndex];
                postItem.values['fld_' + csvFields[j].Id] = csvValue;
            }

            postData.push(postItem);
        }

        let saveDataUrl = rootUrl + "EntityForm/SaveBulkData";

        showLoadingPanel();

        $.ajax({
            type: "POST",
            url: saveDataUrl,
            async: true,
            data: JSON.stringify(postData),
            contentType: "application/json; charset=utf-8",
            success: (result) => {
                hideLoadingPanel();
                $('#' + this.listControlId).data('kendoGrid').dataSource.read();
            },
            error: (e) => {
                hideLoadingPanel();
                toastr.error(e.responseText, this.getEntityFormResources('GetListError'));
            }
        });
    }

    _extractFields(item, fields) {
        if (item.TypeName == 'UIFieldControlDto') {
            fields.push(item);
        }

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                this._extractFields(child, fields);
            });
        }
    }

    _csvToArray(strData, strDelimiter) {
        strDelimiter = (strDelimiter || ",");

        let commaOccurence = strData.split(',');
        let semicolonOccurence = strData.split(';');

        if (semicolonOccurence.length > commaOccurence.length) {
            strDelimiter = ';';
        }

        let objPattern = new RegExp(
            (
                // Delimiters.
                "(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +

                // Quoted fields.
                "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +

                // Standard fields.
                "([^\"\\" + strDelimiter + "\\r\\n]*))"
            ),
            "gi"
        );

        let arrData = [[]];

        let arrMatches = null;

        while (arrMatches = objPattern.exec(strData)) {
            let strMatchedDelimiter = arrMatches[1];

            if (strMatchedDelimiter.length && strMatchedDelimiter !== strDelimiter) {
                arrData.push([]);

            }

            let strMatchedValue;

            if (arrMatches[2]) {
                strMatchedValue = arrMatches[2].replace(new RegExp("\"\"", "g"), "\"");

            } else {
                strMatchedValue = arrMatches[3];
            }

            arrData[arrData.length - 1].push(strMatchedValue);
        }

        return (arrData);
    }

    _handleRefresh() {
        $('#' + this.listControlId).data('kendoGrid').dataSource.read();
    }

    _handleGeneralImportExcel(id) {
        let importCommand = JSON.parse(this.toolbarActions.filter(row => { return row.name == 'custom_' + id })[0].command);
        this.currentCsvCommand = importCommand;
        $('#' + this.csvInputId).click();
    }

    _handleGeneralJavascript(id){
        if (window['btn_' + id + '_onClick'] != null) {
            window['btn_' + id + '_onClick']();
        }
    }

    _generateUUID() {
        var d = new Date().getTime();
        var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16;
            if (d > 0) {
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            } else {
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        }).replaceAll('-', '');
    }

    _initModal(url) {
        if (url.indexOf('?') >= 0) {
            url += '&context=modal&parentGuid=' + this.uniqueControlId;
        } else {
            url += '?context=modal&parentGuid=' + this.uniqueControlId;
        }

        if (this.parent != null) {
            $('#' + this.parent.uniqueModalId)[0].innerHTML = `<div class="pt-2 pb-2" id="` + this.modalInner + `"></div>`;
        } else {
            $('#' + this.modalWrapperUniqueId)[0].innerHTML = `<div class="pt-2 pb-2" id="` + this.modalInner + `"></div>`;
        }

        let modalOptions = {
            draggable: false,
            resizable: true,
            width: "70%",
            height: "auto",
            title: '',
            modal: true,
            content: {
                url: url
            },
            close: () => { this.closeModal(); }
        };

        $('#' + this.modalInner).kendoWindow(modalOptions);
        this.centerModal();

        if (this.displayContext == 'modal') {
            $('#' + this.listControlId).closest('.k-widget.k-window').hide();
        }
    }

    centerModal() {
        $('#' + this.modalInner).data("kendoWindow").center();
    }

    closeModal() {
        $('#' + this.modalInner).data("kendoWindow").destroy();

        if (this.displayContext == 'modal') {
            $('#' + this.listControlId).closest('.k-widget.k-window').show();
        }

        if (this.listType == 'CAROUSEL') {
            $('#' + this.listControlId)[0].innerHTML = '';
            this._initCarouselControl();
        } else {
            $('#' + this.listControlId).data('kendoGrid').dataSource.read();
        }
    }

    notifyFilters(filters) {
        var keys = Object.keys(filters.values);

        this.filters = {};

        keys.forEach(key => {
            if (key.indexOf('fld_') == 0 && filters.values[key] != null) {
                this.filters[key] = filters.values[key];
            }
        });

        $('#' + this.listControlId).data('kendoGrid').dataSource.read();
    }

    initStructure() {
        let structure = ``;

        if (this.parent == null) {
            structure = `<div id="` + this.listControlTitleId + `" style="margin-left: 1rem; margin-top: 1rem;"><p style="font-size: 1.1rem; font-weight: 400; margin-bottom: 0;">` + this.listName + `</p></div><div id="` + this.filterControlId + `"></div><div id="` + this.listControlId + `" style="background-color: transparent;` + (this.listType == 'CAROUSEL' ? (this.parent == null ? ` height: 600px;` : `height: calc(100% - 2rem);`) : ``) + `"` + (this.listType == 'CAROUSEL' ? ` class="p-3"` : ``) + `></div><input id="` + this.csvInputId + `" class="form-control" accept=".csv" required="" type="file" style="display: none;">`;
        } else {
            structure = `<div id="` + this.filterControlId + `"></div><div id="` + this.listControlId + `" style="background-color: transparent;` + (this.listType == 'CAROUSEL' ? (this.parent == null ? ` height: 600px;` : `height: calc(100% - 2rem);`) : ``) + `"` + (this.listType == 'CAROUSEL' ? ` class="p-3"` : ``) + `></div><input id="` + this.csvInputId + `" class="form-control" accept=".csv" required="" type="file" style="display: none;">`;
        }

        $('#' + this.containerId).append(structure);
    }

    getDataSource() {
        let dataSource = null;

        if (this.isPreview) {
            dataSource = new kendo.data.DataSource(this.getPreviewDataSourceOptions());
        } else {
            dataSource = new kendo.data.DataSource(this.getRuntimeDataSourceOptions());
        }

        return dataSource;
    }

    getPreviewDataSourceOptions() {
        let modelFields = {};

        this.fields.forEach(field => {
            if (field.fieldDataType == 'DATE' || field.fieldDataType == 'TIMESTAMP') {
                modelFields[field.id] = {
                    type: 'date'
                };
            } else if (field.fieldDataType == 'NUMERIC' || field.fieldDataType == 'INTEGER') {
                modelFields[field.id] = {
                    type: 'number'
                };
            } else {
                modelFields[field.id] = {
                    type: 'string'
                };
            }
        });

        let options = {
            schema:
            {
                data: "Data",
                total: "Total",
                model: {
                    id: this.idField.toLowerCase(),
                    fields: modelFields
                }
            },
            data: this.getPreviewData(1),
            serverPaging: this.pageType == 'SERVER_PAGING' || this.pageType == 'VIRTUAL',
            serverSorting: this.pageType == 'SERVER_PAGING' || this.pageType == 'VIRTUAL',
            pageable: this.pageType == 'SERVER_PAGING' || this.pageType == 'CLIENT_PAGING',
            sortable: {
                mode: this.sortType
            }
        };

        if (this.getPageable() != false) {
            options.pageSize = this.pageable.pageSize;
        }

        return options;
    }

    getPreviewData(count) {
        if (this.fields.length == 0) {
            return {
                Data: [],
                Total: 0
            };
        }

        let result = {
            Data: [],
            Total: count
        };

        for (var a = 0; a < count; a++) {
            let data = {};

            for (var i = 0; i < this.fields.length; i++) {
                switch (this.fields[i].fieldDataType) {
                    case 'STRING': data[this.fields[i].id] = 'Valoare';
                        break;
                    case 'NUMERIC': data[this.fields[i].id] = 1.0;
                        break;
                    case 'INTEGER': {
                        switch (this.fields[i].fieldDataSubType) {
                            case 'FOREIGN_KEY': data[this.fields[i].id + '_fktext'] = 'Valoare Nomenclator';
                                break;
                            default: data[this.fields[i].id] = 1;
                                break;
                            }
                        } 
                        break;
                    case 'DATE': data[this.fields[i].id] = '04.04.2023';
                        break;
                    case 'TIMESTAMP': data[this.fields[i].id] = '04.04.2023 12:00:00';
                        break;
                    case 'GEOMETRY': data[this.fields[i].id] = 'N/A';
                        break;
                    case 'BYTEA': data[this.fields[i].id] = 'N/A';
                        break;
                    case 'BOOLEAN': data[this.fields[i].id] = 'True';
                        break;
                    case 'BoolInt': data[this.fields[i].id] = 1;
                        break;
                }
            }

            data.xp_allow_del = '1';
            data.xp_allow_edit = '1';

            result.Data.push(data);
        }

        return result;
    }

    getRuntimeDataSourceOptions() {
        let modelFields = {};
        let group = [];

        this.fields.forEach(field => {
            if (field.fieldDataType == 'DATE' || field.fieldDataType == 'TIMESTAMP') {
                modelFields[field.id] = {
                    type: 'date'
                };
            } else if (field.fieldDataType == 'NUMERIC' || field.fieldDataType == 'INTEGER') {
                modelFields[field.id] = {
                    type: 'number'
                };
            } else {
                modelFields[field.id] = {
                    type: 'string'
                };
            }

            //if (field.groupable) {
            //    group.push({ field: field.id });
            //}
        });

        if (Object.keys(modelFields).length == 0) {
            return [];
        }

        let dataSourceUrl = '';

        if (this.getDataUrl == null || this.getDataUrl.trim() == '') {
            if (this.parent != null) {
                dataSourceUrl = 'EntityList/GetSubListData';
            } else {
                dataSourceUrl = 'EntityList/GetData';
            }
        } else {
            dataSourceUrl = this.getDataUrl.substring(1);
        }

        let options = {
            schema:
            {
                data: "Data",
                total: "Total",
                model: {
                    id: this.idField.toLowerCase(),
                    fields: modelFields
                }
            },
            transport: {
                read: {
                    type: 'GET',
                    dataType: 'json',
                    contentType: 'application/json',
                    url: this.rootUrl + dataSourceUrl
                },
                parameterMap: (data, type) => {
                    if (type == 'read') {
                        if (this.parent != null) {
                            data.idUISubList = this.uiLayoutId;
                            data.pkVal = this.parentPkVal;
                        } else {
                            data.id = this.listId;
                        }

                        data.filters = JSON.stringify(this.filters);

                        if (data.sort != null && data.sort.length > 0) {
                            let orderBy = {};

                            for (let i = 0; i < data.sort.length; i++) {
                                for (let j = 0; j < this.fields.length; j++) {
                                    let field = this.fields[j];

                                    if (data.sort[i].field == field.id) {
                                        orderBy[field.id.replaceAll(this.fieldPrefix, '').replaceAll('_', '-')] = data.sort[i].dir;
                                    }
                                }
                            }

                            data.orderby = JSON.stringify(orderBy);
                        }

                        return data;
                    } else {
                        return data;
                    }
                }
            },
            serverPaging: this.pageType == 'SERVER_PAGING' || this.pageType == 'VIRTUAL',
            serverSorting: this.pageType == 'SERVER_PAGING' || this.pageType == 'VIRTUAL',
            pageable: this.pageType == 'SERVER_PAGING' || this.pageType == 'CLIENT_PAGING',
            sortable: {
                mode: this.sortType
            },
            //group: group
        };

        if (this.getPageable() != false) {
            options.pageSize = this.pageable.pageSize;
        }

        return options;
    }

    getToolbarButtons(buttons) {
        let result = [];

        if (buttons != null && buttons.length > 0) {
            buttons.forEach(button => {
                if (button.attr != null && button.attr.length > 0 && button.attr.indexOf('Href = "') >= 0) {
                    let urlPart = button.attr.substr(button.attr.indexOf('Href = "') + 'Href = "'.length);
                    let actualUrl = urlPart.substr(0, urlPart.indexOf('"'));

                    button.attr = button.attr.replaceAll('Href = "' + actualUrl + '"', 'Href = "#"');

                    actualUrl = this.replaceUrlTokens(actualUrl);

                    if (actualUrl.indexOf('/') == 0 && actualUrl.indexOf(this.rootUrl) == -1) {
                        actualUrl = this.rootUrl + actualUrl.substr(1);
                    }

                    button.attr += ' action-url="' + actualUrl + '"';
                }

                if (button.attr != null && button.attr.length > 0 && button.attr.indexOf('Href="') >= 0) {
                    let urlPart = button.attr.substr(button.attr.indexOf('Href="') + 'Href="'.length);
                    let actualUrl = urlPart.substr(0, urlPart.indexOf('"'));

                    button.attr = button.attr.replaceAll('Href="' + actualUrl + '"', 'Href="#"');

                    actualUrl = this.replaceUrlTokens(actualUrl);

                    if (actualUrl.indexOf('/') == 0 && actualUrl.indexOf(this.rootUrl) == -1) {
                        actualUrl = this.rootUrl + actualUrl;
                    }

                    button.attr += ' action-url="' + actualUrl + '"';
                }

                if (button.attr != null && button.attr.length > 0 && button.attr.indexOf('class="') >= 0) {
                    let classPart = button.attr.substr(button.attr.indexOf('class="') + 'class="'.length);
                    let actualClass = classPart.substr(0, classPart.indexOf('"'));
                    button.attr = button.attr.replaceAll('class="' + actualClass + '"', '');
                    button.attr += 'class="' + actualClass + ' list-action-button' + this.uniqueId + '"';
                } else {
                    if (button.attr == null) {
                        button.attr = '';
                    }
                    button.attr += 'class="list-action-button' + this.uniqueId + '"';
                }

                if (button.click != null && button.click.trim() != '') {
                    button.attr += ' btn-click="' + button.click + '" action-id="' + button.name.replaceAll('custom_', '') + '"';
                }

                result.push(button);
            });
        }

        return result;
    }

    handleButtonClick(item) {
       
    }

    getColumns(useStickyColumns) {
        let result = [];        
        this.fields.forEach(configField => {
            if (!configField.hidden) {
                let htmlAttributtes = configField.htmlAttributes;

                if (htmlAttributtes == null) {
                    htmlAttributtes = {};
                }

                let column = {
                    field: configField.id,
                    title: configField.name,
                    width: configField.width,
                    attributes: htmlAttributtes,
                    headerAttributes: {
                        style: 'text-align: center; justify-content: center'
                    },
                    sortable: configField.sortable == true,
                    groupable: configField.groupable == true
                };

                if (configField.fieldDataSubType == 'FOREIGN_KEY') {
                    column.field = configField.id + '_fktext';
                }

                if ((configField.fieldDataSubType == 'FILE' && configField.controlType == 1) || (configField.fieldDataType == 'BYTEA' && configField.controlType == 1)) {
                    column.template = (dataItem) => {
                        if (this.isPreview) {
                            return '<img class="d-block" src="' + (this.rootUrl + 'img/card-backgrounds/cover-1-lg.png') + '" height="50" width="100"></img>';
                        } else {
                            let idEntityField = configField.fieldIdEntityField;
                            let pkVal = dataItem[this.idField];
                            return '<img class="d-block" src="' + (dataItem[configField.id] != null ? (this.rootUrl + 'Entity/GetFileContent?idEntityField=' + idEntityField + '&pkVal=' + pkVal) : null) + '" height="50" width="100"></img>';
                        }
                    };
                } else if ((configField.fieldDataSubType == 'FILE' && configField.controlType == 0) || (configField.fieldDataType == 'BYTEA' && configField.controlType == 0) || configField.fieldDataSubType == 'URL') {
                    column.template = (dataItem) => {
                        let url = '';

                        if (configField.fieldDataSubType == 'URL') {
                            if (dataItem[configField.id] == null || dataItem[configField.id] == '') {
                                url = '#';
                            } else {
                                url = dataItem[configField.id];
                            }
                        } else {
                            if (dataItem[configField.id] == null || dataItem[configField.id] == '' || dataItem[configField.id] == 'false') {
                                return '';
                            }
                            else {
                                let idEntityField = configField.fieldIdEntityField;
                                let pkVal = dataItem[this.idField];
                                url = dataItem[configField.id] != null ? (this.rootUrl + 'Entity/GetFileContent?idEntityField=' + idEntityField + '&pkVal=' + pkVal) : '#';
                            }

                        }

                        if (configField.format != null && configField.format.trim() != '' && configField.format.indexOf('{URL}') >= 0) {
                            return configField.format.replaceAll('{URL}', url);
                        } else {
                            return this.getLayoutResource('ListUrlTemplate').replaceAll('{URL}', url);
                        }
                    };
                } else if (configField.format != null && configField.format.trim() != ''){
                    column.format = configField.format;
                } else if (configField.boolFormat != null && configField.boolFormat.trim() != '') {
                    column.template = (dataItem) => {
                        let val = this._parseBooleanCommandResult(dataItem[configField.id]);

                        let boolTuples = configField.boolFormat.split(':');

                        if (boolTuples.length != 2) {
                            boolTuples = ['NU', 'DA'];
                        }

                        if (val) {
                            return boolTuples[1];
                        } else {
                            return boolTuples[0];
                        }
                    };
                } 

                if (column.template == null && configField.fieldDataType != 'DATE' && configField.fieldDataType != 'TIMESTAMP') {
                    column.template = (dataItem) => {
                        if (dataItem[configField.id] == null || dataItem[configField.id] == '') {
                            return '<div style="height: calc(1.24rem);"></div>';
                        } else {
                            if (configField.fieldDataSubType == 'FOREIGN_KEY') {
                                return dataItem[configField.id + '_fktext'];
                            } else {
                                return dataItem[configField.id];
                            }
                        }
                    }
                }

                result.push(column);
            }
        });

        let actionColumn = this.getActionColumn(useStickyColumns);

        if (actionColumn != null) {
            result.push(actionColumn);
        }

        return result;
    }

    _parseBooleanCommandResult(item) {
        if (item == null) {
            return false;
        }

        if (item == 1 || item == '1' || item == true || item == 'true' || item == 'True') {
            return true;
        }

        if (item == 0 || item == '0' || item == false || item == 'false' || item == 'False') {
            return false;
        }

        let keys = Object.keys(item);

        if (keys.length > 0) {
            let value = item[keys[0]];

            if (value == 1 || value == '1' || value == true || value == 'true' || value == 'True') {
                return true;
            }

            if (value == 0 || value == '0' || value == false || value == 'false' || value == 'False') {
                return false;
            }
        }

        return false;
    }

    handleShowInMapVisibility(item, idEntityField) {
        let contextFields = this.fields.filter(row => { return row.fieldIdEntityField == idEntityField });

        if (contextFields.length > 0) {
            return item[contextFields[0].id] == 'true';
        }
        
        return false;
    }

    handleItemAction(item, actionType, action) {
        switch (actionType) {
            case 'btnEditItem_onClick': this.handleEdit(item);
                break;
            case 'btnViewItem_onClick': this.handleView(item, action);
                break;
            case 'btnDelItem_onClick': this.handleDelete(item);
                break;
            case 'btnShowMapItem_onClick': this.handleShowMapItem(item, action);
                break;
            case 'btnJsItem_onClick': this.handleJsItem(item, action);
                break;
            case 'btnEditItem_visible': return item.xp_allow_edit;
                break;
            case 'btnDelItem_visible': return item.xp_allow_del;
                break;
            case 'btnViewItem_visible': return true;
                break;
            case 'btnShowMapItem_visible': return true;
                break;
            case 'btnJsItem_visible': return true;
                break;
            default: return this.handleDefaultAction(item, actionType);
                break;
        }
    }

    handleDefaultAction(item, actionType) {
        this.fields.forEach(field => {
            if (actionType.indexOf('{' + field.fieldName + '}') > 0) {
                actionType = actionType.replaceAll('{' + field.fieldName + '}', item[field.id]);
            }
        });

        if (this.parent == null && this.displayContext != 'modal') {
            $.pjax({ url: actionType, container: '#js-page-content', timeout: 10000 })
        } else {
            this._initModal(actionType);
        }
    }

    handleShowMapItem(item, action) {
        let idPart = action.attr.replaceAll('IdLayerTarget="', '');
        let layerId = idPart.substr(0, idPart.indexOf('"'));

        if (mapCtrl != null) {
            let layerSettings = mapCtrl.config.layersSettings.filter(row => { return row.layerId == layerId })[0];

            let mapLayerId = layerSettings.id;
            let featureId = item[this.idField];

            let scale = null;

            if (layerSettings.geometryType == 'POINT') {
                scale = 500;
            }

            mapCtrl.showFeature(mapLayerId, featureId, scale, () => { }, () => { });
        }
    }

    handleJsItem(item, action) {
        if (window['btn_' + action.id + '_onClick'] != null) {
            let dataItem = {};

            this.fields.forEach(field => {
                dataItem[field.fieldName] = this._cloneItem(field);
                dataItem[field.fieldName].value = item[field.id];
            });

            window['btn_' + action.id + '_onClick'](dataItem);
        }
    }

    _cloneItem(item) {
        return JSON.parse(JSON.stringify(item));
    }

    handleDelete(item) {
        confirmDialog.fire({
            title: this.getEntityFormResources('DeleteItemTitle'),
            text: this.getEntityFormResources('DeleteItemContent'),
        }).then((result) => {
            if (result.value) {
                let url = this.rootUrl + 'Entity/DeleteData';
                let data = {
                    pkVal: item[this.idField].toString(),
                    idEntity: this.entityId
                };

                $.ajax({
                    type: "POST",
                    url: url,
                    async: true,
                    data: JSON.stringify(data),
                    contentType: "application/json; charset=utf-8",
                    success: (result) => {
                        if (this.listType == 'CAROUSEL') {
                            $('#' + this.listControlId)[0].innerHTML = '';
                            this._initCarouselControl();
                        } else {
                            $('#' + this.listControlId).data('kendoGrid').dataSource.read();
                        }
                    },
                    error: (e) => {
                        toastr.error(this.getEntityFormResources('RemoveItemError'));
                    }
                });
            }
        });
    }

    handleEdit(item) {
        let url = this.editItemUrl;
        if (url == null || url == "") {
            url = this.rootUrl + 'EntityForm/EntityFormRuntime';
        } else {
            if (url.indexOf(this.rootUrl) == -1) {
                url = this.rootUrl + url.substring(1);
            }
        }

        url = this.replaceUrlTokens(url);

        url = url.replaceAll("[id]", item[this.idField].toString());
        url = url.replaceAll("[pkVal]", item[this.idField].toString());

        let itemKeys = Object.keys(item).filter(row => { return row.indexOf("fld_") == 0; });

        itemKeys.forEach(itemKey => {
            url = url.replaceAll('{' + itemKey + '}', item[itemKey]);
        });

        if (this.parent == null && this.displayContext != 'modal') {
            $.pjax({ url: url, container: '#js-page-content', timeout: 10000 })
        } else {
            this._initModal(url);
        }
    }

    handleView(item, command) {
        let actualUrl = '';

        if (command.attr != null && command.attr.length > 0 && command.attr.indexOf('Href = "') >= 0) {
            let urlPart = command.attr.substr(command.attr.indexOf('Href = "') + 'Href = "'.length);
            actualUrl = urlPart.substr(0, urlPart.indexOf('"'));

            command.attr = command.attr.replaceAll('Href = "' + actualUrl + '"', 'Href = "#"');
            command.attr += ' actual-url="' + actualUrl + '"';
        }

        if (command.attr != null && command.attr.length > 0 && command.attr.indexOf('Href="') >= 0) {
            let urlPart = command.attr.substr(command.attr.indexOf('Href="') + 'Href="'.length);
            actualUrl = urlPart.substr(0, urlPart.indexOf('"'));

            command.attr = command.attr.replaceAll('Href="' + actualUrl + '"', 'Href="#"');
            command.attr += ' actual-url="' + actualUrl + '"';
        }

        if (command.attr != null && command.attr.length > 0 && command.attr.indexOf('actual-url="') >= 0) {
            let urlPart = command.attr.substr(command.attr.indexOf('actual-url="') + 'actual-url="'.length);
            actualUrl = urlPart.substr(0, urlPart.indexOf('"'));
        }

        if (actualUrl.indexOf('/') == 0 && actualUrl.indexOf(this.rootUrl) == -1) {
            actualUrl = this.rootUrl + actualUrl.substr(1);
        }

        if (actualUrl == null || actualUrl == "") {
            actualUrl = this.rootUrl + 'EntityForm/EntityFormRuntime';
        } else {
            if (actualUrl.indexOf(this.rootUrl) == -1) {
                actualUrl = this.rootUrl + actualUrl.substring(1);
            }
        }

        actualUrl = this.replaceUrlTokens(actualUrl);

        actualUrl = actualUrl.replaceAll("[id]", item[this.idField].toString());
        actualUrl = actualUrl.replaceAll("[pkVal]", item[this.idField].toString());

        let itemKeys = Object.keys(item).filter(row => { return row.indexOf("fld_") == 0; });

        itemKeys.forEach(itemKey => {
            actualUrl = actualUrl.replaceAll('{' + itemKey + '}', item[itemKey]);
        });

        if (this.parent == null && this.displayContext != 'modal') {
            $.pjax({ url: actualUrl, container: '#js-page-content', timeout: 10000 })
        } else {
            this._initModal(actualUrl);
        }
    }

    getActionColumn(useStickyColumns) {
        if (this.itemActions == null || this.itemActions.length == 0) {
            return null;
        }

        let actionColumn = {
            title: '',
            attributes: {
                style: 'text-align: center; text-overflow: clip;'
            },
            locked: useStickyColumns,
            headerAttributes: { style: 'text-align: center; justify-content: center;' }
        };

        let commands = [];

        const ref = this;

        this.itemActions.forEach(itemAction => {
            var clickAction = itemAction.click;
                        
            let command = {
                attr: itemAction.attr,
                name: itemAction.name,
                text: itemAction.text,
                iconClass: itemAction.iconClass,
                visible: itemAction.visible
            };

            if (clickAction != null) {
                command.click = function (e) {
                    e.preventDefault();
                    let dataItem = this.dataItem($(e.currentTarget).closest("tr"));

                    itemAction.id = itemAction.name.replaceAll('custom_', '');

                    ref.handleItemAction(dataItem, clickAction, itemAction);
                };
            } else {
                let actualUrl = '';

                if (command.attr != null && command.attr.length > 0 && command.attr.indexOf('Href = "') >= 0) {
                    let urlPart = command.attr.substr(command.attr.indexOf('Href = "') + 'Href = "'.length);
                    actualUrl = urlPart.substr(0, urlPart.indexOf('"'));

                    command.attr = command.attr.replaceAll('Href = "' + actualUrl + '"', 'Href = "#"');
                }

                if (command.attr != null && command.attr.length > 0 && command.attr.indexOf('Href="') >= 0) {
                    let urlPart = command.attr.substr(command.attr.indexOf('Href="') + 'Href="'.length);
                    actualUrl = urlPart.substr(0, urlPart.indexOf('"'));

                    command.attr = command.attr.replaceAll('Href="' + actualUrl + '"', 'Href="#"');
                }

                if (actualUrl.indexOf('/') == 0 && actualUrl.indexOf(this.rootUrl) == -1) {
                    actualUrl = this.rootUrl + actualUrl.substr(1);
                }

                command.click = function (e) {
                    e.preventDefault();
                    let dataItem = this.dataItem($(e.currentTarget).closest("tr"));
                    ref.handleItemAction(dataItem, actualUrl, itemAction);
                };
            }

            commands.push(command);
        });

        actionColumn.command = commands;

        if (commands.length == 1) {
            actionColumn.width = 64;
        } else {
            actionColumn.width = (commands.length * 4 * 16);
        }

        return actionColumn;
    }

    getPageable() {
        if (this.pageType == 'NONE') {
            return false;
        } else {
            let pageable = {};
            pageable.pageSizes = this.pageable.pageSizes;
            return pageable;
        }
    }

    getSortable() {
        switch (this.sortType) {
            case 'none': return false;
            case 'simple': return {
                mode: 'single',
                allowUnsort: true,
                showIndexes: true
            };
            case 'multiple': return {
                mode: 'multiple',
                allowUnsort: true,
                showIndexes: true
            };
            case 'mixed': return {
                mode: 'mixed',
                allowUnsort: true,
                showIndexes: true
            };
        }

        return false;
    }

    extractFields(fields) {
        let result = [];
        fields.forEach(item => {
            let fieldId = this.fieldPrefix + item.Id;
            let field = {
                controlType: item.ControlType,
                description: item.Description,
                groupable: item.Groupable,
                id: fieldId.replaceAll('-', '_'),
                name: item.Name,
                sortable: item.Sortable,
                width: item.Width != null && item.Width != 0 ? item.Width * 16 : 160,
                htmlAttributes: item.HtmlAttributes,
                fieldDataType: item.FieldDataType != null ? item.FieldDataType : item.DataType,
                fieldDataSubType: item.DataSubType,
                fieldSpecialFieldType: item.SpecialFieldType,
                fieldIdEntityField: item.IdEntityField,
                fieldName: item.FieldName,
                hidden: item.Hidden
            };

            if (item.DataType == 'BOOLEAN' || item.DataType == 'BOOLINT') {
                field.boolFormat = item.DisplayFormat;
            } else {
                field.format = item.DisplayFormat;
            }

            result.push(field);
        });

        return result;
    }

    getGeneralResource(name) {
        if (this.generalResources[name] != null && this.generalResources[name].trim() != '') {
            return this.generalResources[name];
        }

        return name;
    }

    replaceUrlTokens(url) {
        if (this.urlParameters != null && this.urlParameters.length > 0) {
            let keys = Object.keys(this.urlParameters);

            keys.forEach(key => {
                url = url.replaceAll('{' + key + '}', this.urlParameters[key]);
            });
        }

        return url;
    }

    getEntityFormResources(name) {
        if (this.entityFormResources[name] != null && this.entityFormResources[name].trim() != '') {
            return this.entityFormResources[name];
        }

        return name;
    }

    getLayoutResource(name) {
        if (this.layoutResources[name] != null && this.layoutResources[name].trim() != '') {
            return this.layoutResources[name];
        }

        return name;
    }

    applyStyles() {
        if (!this.styleApplied) {
            this.applyListStyle('.k-grid-content.k-auto-scrollable', 'overflow-y', 'hidden', 'important');
            this.applyListStyle('.k-grid-header', 'padding', '0px 0px 0px 0px', 'important');
            this.applyListStyle('.k-grid-header', 'margin-left', '1px');
            this.applyListStyle('.k-grid-header', 'flex-flow', 'row-reverse');
            this.applyListStyle('.k-widget.k-combobox.k-combobox-clearable', 'width', '100%');
            this.applyListStyle('.k-grid-content.k-auto-scrollable', 'border-right', '1px solid');
            this.applyListStyle('.k-grid-content.k-auto-scrollable', 'border-color', 'rgba(33, 37, 41, 0.125)');
            this.applyListStyle('.k-grid-content-locked', 'margin-right', '1px');
            this.applyListStyle('.k-grid-content-locked', 'margin-bottom', '-1px');
            this.applyListStyle('.k-grid-content-locked', 'height', 'auto', 'important');
            this.applyListStyle('.k-grid-content-locked', 'margin-top', '-1px');
            this.applyListStyle('.k-grid-content-locked', 'border-bottom', '1px solid');
            this.applyListStyle('.k-grid-content-locked', 'min-height', '3.35rem');
            this.applyListStyle('.k-grid-content-locked', 'border-color', 'rgba(33, 37, 41, 0.125)');
            this.applyListStyle('.k-grid-content.k-auto-scrollable', 'margin-left', '1px');
            this.applyListStyle('table', 'border-left', 'none');
            if (this.listType != 'CAROUSEL') {
                this.applyListStyle(null, 'margin-top', '0');
            }
            this.applyListStyle('.k-grid-toolbar', 'padding-bottom', '0.8rem');
            this.applyListStyle('.k-grid-toolbar', 'padding-top', '0.5rem');
            this.applyListStyle('.k-grid-toolbar', 'padding-right', '0.5rem');
            this.applyListStyle('.k-grid-toolbar', 'padding-left', '0.5rem');
            this.applyListStyle('.k-grid-toolbar', 'border-radius', '0px', 'important');
            this.applyListStyle('.k-grid-toolbar', 'border-width', '0px');
            this.applyListStyle('.k-grid-toolbar', 'padding-left', '0px');
            this.applyListStyle('.k-grid-toolbar', 'padding-right', '0px');
            this.applyListStyle('.k-grid-content-locked', 'float', 'right');
            this.applyListStyle('.k-grid-header-locked', 'float', 'right');

            this.applyListStyle('.k-grid-content.k-auto-scrollable', 'border-bottom', '1px solid rgba(33, 37, 41, 0.125)', 'important');
            this.applyListStyle('.k-grid-content.k-auto-scrollable', 'border-left', '1px solid rgba(33, 37, 41, 0.125)', 'important');
            this.applyListStyle('.k-grid-content.k-auto-scrollable', 'padding-bottom', '0.5px', 'important');
            this.applyListStyle('[role="grid"]', 'border', '0 rgba(33, 37, 41, 0.125)', 'important');
            this.applyListStyle('.k-grid-header-wrap.k-auto-scrollable', 'border-left', '1px solid rgba(33, 37, 41, 0.125)', 'important')
            this.applyListStyle('.k-grid-header-wrap.k-auto-scrollable', 'border-top', '1px solid rgba(33, 37, 41, 0.125)', 'important')

            if (this.parent == null) {
                this.applyStyle('#' + this.containerId, 'background-color', 'white');
            } else {
                this.applyStyle('#' + this.containerId + ' .k-grid-toolbar', 'background-color', 'transparent');
                this.applyStyle('#' + this.containerId + ' .k-grid-pager', 'background-color', 'transparent');
            }

            if (this.listType != 'CAROUSEL') {
                new ResizeSensor($("#" + this.listControlId), () => {
                    this._adjustLastColumn();
                });
            }

            this.styleApplied = true;
        }
    }

    applyListStyle(selector, property, value, extra) {
        if (selector != null) {
            this.applyStyle('#' + this.listControlId + ' ' + selector, property, value, extra);
        } else {
            this.applyStyle('#' + this.listControlId, property, value, extra);
        }
    }

    applyStyle(selector, property, value, extra) {
        try {
            let elements = document.querySelectorAll(selector);
            if (elements) {
                elements.forEach(element => {
                    if (extra) {
                        element.style.setProperty(property, value, extra);
                    } else {
                        element.style.setProperty(property, value);
                    }
                });
            }
        } catch {

        }
    }
}